import { TabInterface } from "components/layout/interfaces";
import Tabs from "components/layout/tabs";
import View from "components/layout/view";
import Title from "components/title";
import { FunctionComponent } from "react";
import EmailConfigurationTab from "./email-configuration/email-configuration-tab";
import AdminsTab from "./admins/admins-tab";
import PrivacyPolicyTab from "./privacy-policy/privacy-policy-tab";
import BaseTab from "./base/base-tab";

const AdminSettingsView: FunctionComponent = () => {
  const tabs: TabInterface[] = [
    {
      key: "base",
      label: "Perusasetukset",
      render: () => <BaseTab />,
    },
    {
      key: "admins",
      label: "Ylläpitäjät",
      render: () => <AdminsTab />,
    },
    {
      key: "privacy-policy",
      label: "Tietosuojaseloste",
      render: () => <PrivacyPolicyTab />,
    },
    {
      key: "email-configuration",
      label: "Sähköpostiasetukset",
      render: () => <EmailConfigurationTab />,
    },
  ];

  return (
    <View title="Organisaatio" description="">
      <Title>Organisaatio</Title>
      <Tabs name="settings" tabs={tabs} />
    </View>
  );
};

export default AdminSettingsView;
